import React from "react";
import { cn } from "../../lib/utils";

const variants = {
  default: "border-border bg-background text-foreground focus:ring-primary",
  primary: "border-primary bg-background text-foreground focus:ring-primary",
  secondary: "border-secondary bg-secondary text-foreground focus:ring-secondary",
  error: "border-red-500 bg-white text-red-700 focus:ring-red-500",
  retro: "border-green-400 bg-black text-green-300 font-retro focus:ring-green-400",
};

const sizes = {
  sm: "h-8 px-2 text-sm",
  md: "h-10 px-3 text-base",
  lg: "h-12 px-4 text-lg",
};

export function Input({
  className,
  variant = "default",
  size = "md",
  ...props
}) {
  return (
    <input
      className={cn(
        "w-full rounded-md py-2 focus:outline-none focus:ring-2 transition",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    />
  );
}